/**
 * @generated SignedSource<<b39fc146f1731227a271de7667ff8751>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type onePostMagSectionTopWidgetArticles$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"postMagazinePrimaryContent">;
  };
  readonly " $fragmentType": "onePostMagSectionTopWidgetArticles";
}>;
export type onePostMagSectionTopWidgetArticles$key = ReadonlyArray<{
  readonly " $data"?: onePostMagSectionTopWidgetArticles$data;
  readonly " $fragmentSpreads": FragmentRefs<"onePostMagSectionTopWidgetArticles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "onePostMagSectionTopWidgetArticles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "postMagazinePrimaryContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "fe9d7e25cb5467a14b7d2681232c184e";

export default node;
